import React from 'react';

import { HeaderLinkBlock } from './HeaderBarStyles';

export const HeaderBarLink = ({
  children,
  name,
  selected,
  onClick,
}: {
  children: React.ReactNode;
  name?: string;
  selected?: boolean;
  onClick?: () => void;
}) => (
  <HeaderLinkBlock data-test={name} selected={selected}>
    {children}
  </HeaderLinkBlock>
);
